import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-20d841d7")

_pushScopeId("data-v-20d841d7")
const _hoisted_1 = { class: "pusat-resolusi-message-wrapper" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HistoryChat = _resolveComponent("HistoryChat")!
  const _component_ChatBoxMessage = _resolveComponent("ChatBoxMessage")!
  const _component_FollowReport = _resolveComponent("FollowReport")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_HistoryChat, {
      detailId: _ctx.detailId,
      websocket: _ctx.websocket,
      caseNumber: _ctx.caseNumber
    }, null, 8, ["detailId", "websocket", "caseNumber"]),
    (!_ctx.isLoadingAction)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.isShowChat)
            ? (_openBlock(), _createBlock(_component_ChatBoxMessage, {
                key: 0,
                modelValue: _ctx.message,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.message = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_ctx.isShowFollow)
            ? (_openBlock(), _createBlock(_component_FollowReport, {
                key: 1,
                onFollowed: _ctx.getTicketAction
              }, null, 8, ["onFollowed"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_Skeleton, { width: "90%" }),
          _createVNode(_component_Skeleton, { width: "70%" }),
          _createVNode(_component_Skeleton, { width: "100%" }),
          _createVNode(_component_Skeleton, { width: "50%" }),
          _createVNode(_component_Skeleton, { width: "70%" })
        ]))
  ]))
})